//个人中心
const Paired = () =>
    import("../views/paired/paired.vue"); //结对空间

export default [{
    path: "/paired",
    name: "paired",
    component: Paired,
    meta: {
        title: "结对空间",
        keepAlive: false
    },

}]